import React from "react"
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  Label,
  Button,
  Form,
  Input,
  FormFeedback,
  ButtonGroup,
} from "reactstrap"
import * as Yup from "yup"
import { useFormik } from "formik"
import { useSelector, useDispatch } from "react-redux"
import { useParams } from "react-router-dom"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

import { editOffice, updateOffice } from "../../../store/actions"

import { useEffect, useState } from "react"

const EditOffice = props => {
  const dispatch = useDispatch()
  document.title = "Edit office"
  const { id } = useParams()

  const [details, setDetails] = useState({})

  useEffect(() => {
    dispatch(editOffice(id))
  }, [dispatch])

  const office = useSelector(state => state.Office)

  useEffect(() => {
    let officeName = []
    if (office && office.office && office.office.length > 0) {
      officeName = office.office.filter(Office => Office.office_id == id)
    }
    if (officeName.length > 0) {
      setDetails(officeName[0])
    } else {
      props.history.push("/dropdown/office/list")
    }
  }, [])

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      office_id: details && details.office_id ? details.office_id : "",

      office_name: details && details.office_name ? details.office_name : "",

      is_default: details && details.is_default ? 1 : 0,
    },
    validationSchema: Yup.object({
      office_name: Yup.string().required("Please enter office name"),
    }),
    onSubmit: values => {
      values.office_id = id // colli_id is from api thats why this needs to be same with "id"
      dispatch(updateOffice(values, props.history))
    },
  })

  const { error } = useSelector(state => ({
    error: state.Office.error,
  }))

  useEffect(() => {
    if (error) {
      toast.dismiss()
      toast.error(error, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      })
    }
  }, [error])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs breadcrumbItem="Edit Office" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  {error ? <ToastContainer /> : ""}
                  <Form
                    id="editofficeForm"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    <Row>
                      <Col md={6}>
                        <div className="mb-3 mt-1">
                          <Label htmlFor="office">Office Name</Label>
                          <Input
                            name="office_name"
                            type="text"
                            id="office"
                            autoComplete="off"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.office_name || ""}
                          />
                          {validation.touched.office_name &&
                          validation.errors.office_name ? (
                            <FormFeedback type="invalid">
                              {validation.errors.office_name}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                    <div>
                      <h6>Default : </h6>
                      <ButtonGroup>
                        <Button
                          name="is_default"
                          color="success"
                          outline
                          value={1}
                          active={validation.values.is_default == 1}
                          onClick={validation.handleChange}
                        >
                          Yes
                        </Button>

                        <Button
                          name="is_default"
                          color="secondary"
                          outline
                          value={0}
                          active={validation.values.is_default == 0}
                          onClick={validation.handleChange}
                        >
                          No
                        </Button>
                      </ButtonGroup>
                    </div>
                    <br />
                    <div>
                      {office && office.loading ? (
                        <button
                          type="submit"
                          className="btn btn-primary w-md"
                          disabled
                        >
                          Updating ...
                        </button>
                      ) : (
                        <button type="submit" className="btn btn-primary w-md">
                          Update
                        </button>
                      )}
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        {/* container-fluid */}
      </div>
    </React.Fragment>
  )
}

export default EditOffice
